import React, { useState } from 'react';
import InfinityYoga from '../images/Project-Infinity Yoga.png';
import Figma from '../images/Figma logo.png';

const InfinityYogaStudio = () => {
    return (
        <div>
            <section className='home-hero project-hero'>
                <h6 className='back-link'><a href='/portfolio'>&larr; Back to Portfolio</a></h6>
                <div className='row'>
                <div className='col'><img src={InfinityYoga} alt="portfolio - Infinity Yoga" className="project-main-image" /></div>
                    <div className='col'>
                        <h1>Infinity Yoga Studio</h1>
                        <p>Some text here. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                    </div>
                </div>
            </section>
            <section className='project-technologies'>
                <div>
                    <h6 className="project-heading">
                        01<span>Technologies</span>
                    </h6>
                </div>
                <div className='project-content'>
                <img src={Figma} alt="Figma logo" className="design-tool-image" />
                </div>
            </section>
            <section className='project-typography-color'>
                <div>
                    <h6 className="project-heading">
                        02<span>Typography and Colors</span>
                    </h6>
                </div>
                <div className='project-content'>
                    <p>Font Family: Montserrat</p>
                    
                </div>
            </section>
        </div>
    );
};

export default InfinityYogaStudio;